import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import moment from 'moment';
import DashboardView from 'dashboard/DashboardView.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import PreLoader from 'components/PreLoader/PreLoader.react';
import WorldMap from './WorldMap.react';
import { countries } from './static/countries';
import { isEmptyObject } from 'lib/helpers';

export default class WorldMapHOC extends Component {
  constructor(props) {
    super(props);

    this.section = 'Metrics';
    this.subsection = 'Test';

    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    SashiDo.metricsFilesCountries(this.props.currentApp.id).then((data) => {

      const newData = data.metrics.map((item) => {
        const objKeys = Object.keys(item.value);
        const newValues = [];

        objKeys.forEach((key) => {
          const country = countries.find(u => u.country === key);
          const obj = { ... country };

          if(country) {
            obj.count = item.value[key] || 0;
            newValues.push(obj);
          }
        });


        item.value = newValues;

        return item;
      })
      .filter(u => u)

      this.setState({ newData });
    });
  }

  render() {
    const { props, state } = this;
    const { newData } = state;

    return newData
      ?
        <WorldMap
          {...props}
          title="Delivered Files by Country"
          tooltip='Collecting since Jul 01 2018 and updating every 8 hours.'
          data={newData} />
      : null
  }
}
